/**
 * Computes the new selection values when an option is toggled.
 * For single-select: returns the value directly.
 * For multi-select: toggles the value in the selected array.
 */
export const getNewOptionValues = (
  value: string,
  selectedValues: string[],
  isMulti: boolean
): string | string[] => {
  if (!isMulti) {
    return value;
  }

  if (selectedValues.includes(value)) {
    return selectedValues.filter((v) => v !== value);
  }

  if (selectedValues[0] === undefined) {
    return [value];
  }

  return [...selectedValues, value];
};
